export function loadAudioEye() {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://ws.audioeye.com/ae.js';
    script.async = true;
    document.body.appendChild(script);
}
